<template>
  <div class="blog-posts-page posts">
    <div class="post-list-header row pt-3  align-items-center mb-4">
      <div
        class="page-header col-12 d-flex justify-content-between align-items-center"
      >
        <div class="page-header-left d-flex align-items-center">
          <h1 class="w-full mr-2">Reviews</h1>
        </div>
      </div>
    </div>
    <div class="row">
      <div v-for="page in pages" :key="page.id" class="col-md-4">
        <div
          class="tags-container d-flex justify-between align-items-center pointer"
          @click.prevent="$router.push(`reviews/${page.slug}`)"
        >
          <div>
            <strong>{{ page.name }} </strong>
            <span>({{ page.reviews.length }} Reviews)</span>
          </div>
          <div
            v-if="page.unpublishedReviews.length > 0"
            class="position-relative"
          >
            <!-- <span>{{ page.unpublishedReviews.length }} Unapproved</span> -->
            <div
              :title="page.unpublishedReviews.length + ' unapproved reviews'"
              id="dot"
              class="d-flex align-items-center justify-content-center"
            >
              {{ page.unpublishedReviews.length }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Reviews",
  data: () => ({
    pages: [
      {
        name: "All on 4",
        slug: "all-on-4",
        id: 1,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "All on 6",
        slug: "all-on-6",
        id: 2,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Bezmetalne krunice",
        slug: "bezmetalne-krunice",
        id: 3,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Fasete",
        slug: "fasete",
        id: 4,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Fiksna proteza",
        slug: "fiksna-proteza",
        id: 5,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Folije za ispravljanje zuba",
        slug: "folije-za-ispravljanje-zuba",
        id: 6,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Hollywood smile",
        slug: "hollywood-smile",
        id: 7,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Implanti",
        slug: "implanti",
        id: 8,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Invisalign",
        slug: "invisalign",
        id: 9,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Index",
        slug: "krunice",
        id: 10,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Metalokeramicke krunice",
        slug: "metalokeramicke-krunice",
        id: 11,
        reviews: [],
        unpublishedReviews: []
      },
      {
        name: "Svesna sedacija",
        slug: "svesna-sedacija",
        id: 12,
        reviews: [],
        unpublishedReviews: []
      }
    ],
    meta: {},
    page: 1,
    q: "",
    showFilters: false,
    reviewsLoading: false
  }),
  mounted() {
    for (var page of this.pages) {
      this.getReviews(page.slug);
    }
  },
  methods: {
    getReviews(pageSlug) {
      var page = this.pages.find(item => item.slug === pageSlug);
      this.reviewsLoading = true;
      axios
        .get("/reviews/" + pageSlug)
        .then(resp => {
          page.reviews = resp.data.data;
          var unpublished = resp.data.data.filter(item => item.status == 0);
          if (unpublished.length > 0) {
            page.unpublishedReviews = unpublished;
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.reviewsLoading = false;
        });
    }
  }
};
</script>
<style scoped>
.tags-container {
  background-color: #fff;
  border-radius: 2px;
  margin-bottom: 10px;
  padding: 10px 30px;
}
#dot {
  width: 20px;
  height: 20px;
  border: 1px solid rgb(214, 97, 107);
  background-color: rgba(214, 97, 107, 0.5);
  border-radius: 100%;
  animation: pulsate 2.5s ease-out;
  animation-iteration-count: infinite;
  opacity: 0.5;
  position: absolute;
  transform: translateY(-50%);
}
@keyframes pulsate {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
</style>
